import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import LifeMonitoring from "./pages/LifeMonitoring";
import About from "./pages/About";
import TabsChart from "./pages/TabsChart";
import Blog from "./pages/Blog";
import GatchamonRules from "./pages/GatchamonRules";
import GatchamonRulesOld from "./pages/GatchamonRulesOld";
import { HelmetProvider } from "react-helmet-async";

function App() {

  const [navHeight, setNavHeight] = useState(0);
  const navRef = useRef(null);

  useEffect(() => {
    if (!navRef.current) {
      console.error("Navbar ref is null! Make sure the <nav> element exists and is rendered.");
      return;
    }
    const updateHeight = () => setNavHeight(navRef.current.offsetHeight);

    updateHeight(); // Set initial height
    window.addEventListener("resize", updateHeight); // Update on resize

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <AppContent navHeight={navHeight} navRef={navRef} />
      </Router>
    </HelmetProvider>
  );
}


function AppContent({ navHeight, navRef }) {
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/blog", label: "Blog" },
    { path: "/lifemonitoring", label: "Life Monitoring" },
    { path: "/about", label: "About" },
    { path: "/tabs", label: "How many tabs" },
    // Add more pages here! 🎉
  ];

  const location = useLocation(); // ✅ Now inside <Router>

  return (
    <>

      {/* 🔥 NAVBAR */}
      <nav
        ref={navRef}
        className={`fixed top-0 left-0 w-full py-1 px-6 z-50 transition-colors duration-300
          ${location.pathname === "/tabs" ? "bg-transparent" : "bg-transparent backdrop-blur-lg"}`}
      >
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          {/* Logo / Brand */}
          <Link to="/" className="text-2xl font-bold text-blue-600 hover:text-gray-300 transition">
            <img src="/logo512.png" alt="Logo" className="h-12 w-12	md:h-16 md:w-16" />
          </Link>

          {/* Desktop Links */}
          <div className="hidden md:flex space-x-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-blue-600 hover:text-gray-300 transition"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-blue-600 focus:outline-none" onClick={() => setIsOpen(!isOpen)}>
            <span className="text-2xl">☰</span> {/* Hamburger Icon */}
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {isOpen && (
          <div className="md:hidden flex flex-col space-y-2 mt-2 px-6 bg-customYellowMobileMenu text-blue-600 py-2 rounded-md shadow-lg">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="hover:text-gray-300 transition py-2"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
          </div>
        )}
      </nav>

      <div
        className="min-h-screen overflow-auto bg-customYellow"
      >

      {location.pathname !== "/tabs" && (
        <div className="bg-customYellow w-full"
        style={{height: `${navHeight}px`}} />
      )}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/lifemonitoring" element={<LifeMonitoring />} />
          <Route path="/about" element={<About />} />
          <Route path="/tabs" element={<TabsChart />} />
          <Route path="/gatchamon" element={<GatchamonRules />} />
          <Route path="/gatchamonold" element={<GatchamonRulesOld />} />
        </Routes>
      </div>
    </>

  );
}

export default App;
